import { useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import { v4 as uuidv4 } from "uuid";
import { StyledButton, StyledButtonTypes, StyledTextArea, StyledTextAreaTypes } from "src/components";

import styles from "./styles.module.scss";
import { DraggableNewButtonContent } from "../draggable-new-button-content/draggable-new-button-content";
import { MPDDragDrop } from "src/mpd-library";
import { Text } from "@blueprintjs/core";

const classname = "greeting-message";

export const GreetingMessage = ({
    greetingFormik,
    getFieldProps,
    setFormikState,
    greetingMessage,
    followUpMessage,
    errors,
    touched
}) => {
    const [buttons, setButtons] = useState([]);

    useEffect(() => {
        if (greetingFormik) {
            setFormikState(greetingFormik);
        }
    }, [greetingFormik]);

    const onRemoveButton = useCallback(
        (id: string) => {
            setButtons([...buttons.filter((button) => button.id !== id)]);
        },
        [buttons]
    );

    const onAddNewButton = useCallback(() => {
        const id = uuidv4();
        setButtons([
            ...buttons,
            {
                id,
                name: "",
                queue: "",
                tag_id: ""
            }
        ]);
    }, [buttons]);

    const onButtonNameChange = useCallback(
        (id: string, name: string) => {
            setButtons(
                buttons.map((button) => {
                    if (button.id === id) {
                        return {
                            ...button,
                            name
                        };
                    }
                    return button;
                })
            );
        },
        [buttons]
    );

    // const renderDragableItems = () =>
    //     buttons.map((button) => ({
    //         content: (
    //             <DraggableNewButtonContent
    //                 key={button.id}
    //                 id={button.id}
    //                 onRemoveButton={onRemoveButton}
    //                 onButtonNameChange={onButtonNameChange}
    //                 name={button.name}
    //             />
    //         )
    //     }));

    return (
        <form>
            <div className={classNames(styles[classname], "profile-automations-item-wrapper")}>
                <StyledTextArea
                    className={"profile-automations-section-textarea"}
                    autoCapitalize="none"
                    autoCorrect="none"
                    type={StyledTextAreaTypes.primaryStatic}
                    placeholder={"INITIAL GREETING MESSAGE"}
                    tabIndex={1}
                    rows={5}
                    isMaxLengthRequire={false}
                    value={greetingMessage}
                    showErrorText={true}
                    error={touched.greetingMessage && errors.greetingMessage}
                    {...getFieldProps("greetingMessage")}
                />
                {!!buttons.length && (
                    <div className={styles[`${classname}-column-titles-wrapper`]}>
                        <Text className={styles[`${classname}-column-title`]}>BUTTON NAME</Text>
                        <Text className={styles[`${classname}-column-title`]}>ROUTE TO QUEUE</Text>
                        <Text className={styles[`${classname}-column-title`]}>ADD TAGS</Text>
                    </div>
                )}
                <MPDDragDrop
                    items={buttons.map((button) => ({
                        content: (
                            <DraggableNewButtonContent
                                key={button.id}
                                id={button.id}
                                onRemoveButton={onRemoveButton}
                                onButtonNameChange={onButtonNameChange}
                                name={button.name}
                            />
                        )
                    }))}
                    className={styles[`${classname}-draggable`]}
                    onDragVertical={() => null}
                />
                <StyledButton
                    type={StyledButtonTypes.primarySimple}
                    text={"Add another button..."}
                    onClick={onAddNewButton}
                />
                {/* <DraggableNewButtonContent key={"newKey"} /> */}
                {/* <TagsDropdown setTagsToFilter={selectTag} checkedTags={checkedTags} /> */}
                <StyledTextArea
                    autoCapitalize="none"
                    autoCorrect="none"
                    type={StyledTextAreaTypes.primaryStatic}
                    placeholder={"FOLLOW UP MESSAGE"}
                    tabIndex={1}
                    rows={5}
                    isMaxLengthRequire={false}
                    value={followUpMessage}
                    showErrorText={true}
                    className={"profile-automations-section-textarea"}
                    error={touched.followUpMessage && errors.followUpMessage}
                    {...getFieldProps("followUpMessage")}
                />
            </div>
        </form>
    );
};
